import React from 'react';
import classNames from 'classnames';
import { useRouteMatch } from 'react-router';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';

import { SetupForm } from './SetupForm/SetupForm';

import css from './GoogleAds.module.css';

type Props = {
  className?: string;
};

export const GoogleAds = ({ className }: Props) => {
  const history = useHistory();

  const match = useRouteMatch<{ id?: string; chatbotId: string }>();
  const containerClassName = classNames(className, css.container);

  return (
    <div className={containerClassName}>
      <Switch>
        <Route path={`${match.path}/setup/:step?`} component={SetupForm} />

        <Redirect
          to={{ pathname: `${match.url}/setup`, state: history.location.state }}
        />
      </Switch>
    </div>
  );
};
